import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, BadgeCheck, Link2, Clock } from "lucide-react";

const THEMES = {
  partner: { btn: "bg-white text-black hover:bg-[#e5e5e5]", ok: "text-[#00F593]", pend: "text-[#f5a623]" },
  mentor: { btn: "bg-[#00F593] hover:bg-[#00d47f] text-black", ok: "text-[#00F593]", pend: "text-[#f5a623]" },
};

export function StripeConnectButton({ variant = "partner" }) {
  const t = THEMES[variant] || THEMES.partner;
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadStatus = useCallback(async () => {
    try { const { data } = await api.get("/connect/status"); setStatus(data); }
    catch { /* ignore */ }
  }, []);
  useEffect(() => { loadStatus(); }, [loadStatus]);

  const onboard = async () => {
    setBusy(true);
    try {
      const origin = window.location.origin + window.location.pathname;
      const { data } = await api.post("/connect/onboard", { origin_url: origin });
      if (data?.url) { window.location.href = data.url; return; }
      toast.error("Pa t kapab jenere lyen Stripe la. Eseye ankò.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const connected = status?.connected;
  const pending = status?.connect_id && !status?.connected;

  return (
    <div data-testid={`stripe-connect-${variant}`}>
      <Button onClick={onboard} disabled={busy} data-testid="stripe-connect-button"
        className={`h-11 rounded-xl px-5 font-semibold ${t.btn}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> :
          <><Link2 className="mr-2 h-4 w-4" /> {connected ? "Jere Kont Stripe" : pending ? "Kontinye Konfigirasyon Stripe" : "Konekte Stripe"}</>}
      </Button>
      {connected && (
        <p className={`text-[11px] mt-2 flex items-center gap-1.5 ${t.ok}`} data-testid="stripe-connect-ok">
          <BadgeCheck className="h-3.5 w-3.5" /> Kont Stripe konekte — ou pare pou resevwa peman.
        </p>
      )}
      {pending && (
        <p className={`text-[11px] mt-2 flex items-center gap-1.5 ${t.pend}`} data-testid="stripe-connect-pending">
          <Clock className="h-3.5 w-3.5" /> Konfigirasyon poko fini — peze bouton an pou fini l.
        </p>
      )}
    </div>
  );
}
